/* eslint-disable @typescript-eslint/ban-ts-comment */
import * as React from 'react'
import TextArea from 'ui/atoms/TextArea'

import BaseField, { type Props as FieldProps } from './BaseField'

export type Props = {
  type?: 'text' | 'email' | 'password' | 'url'
} & FieldProps

const TextField: React.ComponentType<Props> = React.forwardRef(
  (props: Props, ref) => {
    const { hasError, type, ...rest } = props

    return (
      <BaseField {...rest} semibold hasError={hasError}>
        <TextArea
          {...rest}
          $hasError={hasError}
          // @ts-ignore
          ref={ref}
          type={type ?? 'text'}
        />
      </BaseField>
    )
  }
)

export default TextField
